var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-header"},[_c('h5',{staticClass:"primary--text mb-1 text-capitalize"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('Divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }